export default "__VITE_ASSET__d82f8dce__"